<div class="group">
  <label>Company</label>
  <input
    data-testid="company-name"
    [formControl]="companyControl"
    type="text"
    placeholder=""
    class="quantum-input"
    [ngClass]="companyControl.invalid ? 'invalid' : ''"
  />
  <div
    *ngIf="
      companyControl.invalid && companyControl.errors && companyControl.dirty
    "
    [class.dirty]="companyControl.dirty"
    class="error-message"
  >
    <div *ngIf="companyControl.errors['required']">
      {{ 'inputs.required' | translate }}
    </div>
  </div>
</div>
